import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { TreePine } from "lucide-react";
import { AppDispatch, RootState } from "../../../store";
import { getReferralTree } from "../../../Redux/referral/slice";
import { TreeNode } from "../../../Redux/referral/types";
import { mapTreeNodeToDisplay } from "../earnings/earningsAdapters";
import ReferralTree from "./ReferralTree";
import "./SalarReferralTree.css";

const Tree = () => {
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const orderNo = queryParams.get("orderNo") || "";
  const type = queryParams.get("type") || "referral"; // referral or nova

  const { referralTree } = useSelector(
    (state: RootState) => state.referral,
  );

  useEffect(() => {
    if (orderNo) {
      dispatch(getReferralTree(orderNo));
    }
  }, [dispatch, orderNo]);

  const treeData: TreeNode | undefined =
    type === "nova"
      ? referralTree.data?.novaReferralNetworkTree?.tree
      : referralTree.data?.referralNetworkTree?.tree;

  const displayTree = treeData ? mapTreeNodeToDisplay(treeData) : null;

  return (
    <section className="ri-page">
      <div className="ri-shell">
        <header className="ri-page-header">
          <div className="ri-page-title">
            <span className="ri-title-icon">
              <TreePine size={25} />
            </span>
            <div>
              <span className="ri-eyebrow">
                {type === "nova" ? "NOVA REFERRAL NETWORK" : "SALAR FLOW NETWORK"}
              </span>
              <h1>
                {type === "nova" ? "Nova Referral Tree" : "Referral Tree"}
              </h1>
              <p>
                Order {orderNo || "—"} · Parent, direct members and deeper
                level referral members.
              </p>
            </div>
          </div>
        </header>

        {referralTree.loading ? (
          <div className="ri-table-wrap" style={{ padding: "40px", textAlign: "center" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : displayTree ? (
          <ReferralTree
            data={displayTree}
            title={
              type === "nova"
                ? "Nova Referral Tree"
                : "Salar Flow Referral Tree"
            }
            subtitle="Move over a member on desktop, or tap on mobile, to distinguish that member and their direct referrals."
          />
        ) : (
          <div className="ri-table-wrap" style={{ padding: "40px", textAlign: "center" }}>
            No tree data found.
          </div>
        )}
      </div>
    </section>
  );
};

export default Tree;
